import { render, staticRenderFns } from "./main.vue?vue&type=template&id=4714cf16"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=4714cf16&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4714cf16')) {
      api.createRecord('4714cf16', component.options)
    } else {
      api.reload('4714cf16', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=4714cf16", function () {
      api.rerender('4714cf16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/basic-container/main.vue"
export default component.exports